
import React, { useState, useEffect } from "react";
import Shlokcard from "./Slokcard";

import photo from "../img/5571946.svg";

const IndividualShlok = (props) => {
const [shlokchapters, setShlokChapters] = useState('1');
const [shlokverse, setShlokVerse] = useState('1');
const [shlok, setShlok] = useState([]);
const [loading, setLoading] = useState(true);

  const nextShlok = () => {
    setLoading(true);
    var chapternum = shlokchapters;
    const a = [
      47, 72, 43, 42, 29, 47, 30, 28, 34, 42, 55, 20, 35, 27, 20, 24, 28, 78,
    ];
    if (
      shlokverse < a[chapternum - 1] &&
      chapternum > 0 &&
      chapternum <= 18
    ) {
      setShlokVerse(parseInt(shlokverse) + 1);
    } else {
      setShlokChapters(parseInt(chapternum) + 1);
      setShlokVerse(1);
    }
    getShlok();
  };

  const previousShlok = () => {
    setLoading(true);
    var chapternum = shlokchapters;
    const a = [
      47, 72, 43, 42, 29, 47, 30, 28, 34, 42, 55, 20, 35, 27, 20, 24, 28, 78,
    ];
    if (shlokverse > a[chapternum - 1]) {
      setShlokVerse(parseInt(shlokverse) - 1);
    } else {
      setShlokChapters(parseInt(chapternum) - 1);
      setShlokVerse(a[chapternum - 2]);
    }
    getShlok();
  };

  const getShlok = () => {
    setLoading(true);
    fetch(
      // `https://bhagvadgitabackend.onrender.com/gita/${shlokchapters}/${shlokverse}`
      `https://vedicscriptures.github.io/slok/${shlokchapters}/${shlokverse}`
    )
      .then((response) => {
        if (!response.ok) {
          setLoading(false);
        }
        return response.json();
      })
      .then((data) => {
        setShlok(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        getShlok();
      });
  };

  useEffect(() => {
    getShlok();
  }, [shlokchapters, shlokverse]);

  return (
    <div className="row">
      <div className="col-md-3"></div>
      <div className="col-md-6">
        <h3 className="h3 text-center">
          अध्यायः{shlokchapters} श्लोक:{shlokverse}
        </h3>
        <h3 className="h3 text-center">
          Chapter:{shlokchapters} Verse:{shlokverse}
        </h3>
        <div className="row">
          <div className="col-6">
            <button className="btn btn-danger" onClick={previousShlok}>
              <i className="far fa-hand-point-left"></i>
            </button>
          </div>
          <div className="col-6 text-end">
            <button className="btn btn-danger" onClick={nextShlok}>
              <i className="far fa-hand-point-right"></i>
            </button>
          </div>
        </div>
        <Shlokcard data={shlok} loading={loading} t={true} />
      </div>
      <div className="col-md-3">
        <img src={photo} alt="bhagvad-gita" />
      </div>
    </div>
  );
};

export default IndividualShlok;



